export const GET_PLACES = "GET_PLACES"
export const GET_PLACES_SUCCESS = "GET_PLACES_SUCCESS"
export const GET_PLACES_FAILED = "GET_PLACES_FAILED"

export const GET_PLACE_DATA = "GET_PLACE_DATA"
export const GET_PLACE_DATA_SUCCESS = "GET_PLACE_DATA_SUCCESS"
export const GET_PLACE_DATA_FAILED = "GET_PLACE_DATA_FAILED"
export const RESET_PLACE_DATA = "RESET_PLACE_DATA"

export const CREATE_PLACE = "CREATE_PLACE"
export const CREATE_PLACE_SUCCESS = "CREATE_PLACE_SUCCESS"
export const CREATE_PLACE_FAILED = "CREATE_PLACE_FAILED"

export const UPDATE_PLACE = "UPDATE_PLACE"
export const UPDATE_PLACE_SUCCESS = "UPDATE_PLACE_SUCCESS"
export const UPDATE_PLACE_FAILED = "UPDATE_PLACE_FAILED"

export const OPEN_CONFIRM_DELETE_MODAL = "OPEN_CONFIRM_DELETE_MODAL"
export const HIDE_CONFIRM_DELETE_MODAL = "HIDE_CONFIRM_DELETE_MODAL"
export const DELETE_PLACE = "DELETE_PLACE"
export const DELETE_PLACE_SUCCESS = "DELETE_PLACE_SUCCESS"
export const DELETE_PLACE_FAILED = "DELETE_PLACE_FAILED"

export const GET_COMPLETED_SURVEYS = "GET_COMPLETED_SURVEYS"
export const GET_COMPLETED_SURVEYS_SUCCESS = "GET_COMPLETED_SURVEYS_SUCCESS"
export const GET_COMPLETED_SURVEYS_FAILED = "GET_COMPLETED_SURVEYS_FAILED"
export const RESET_SURVEYS_DATA = "RESET_SURVEYS_DATA"

export const GET_PLACE_SURVEY_REPLIES = "GET_PLACE_SURVEY_REPLIES"
export const GET_PLACE_SURVEY_REPLIES_SUCCESS =
  "GET_PLACE_SURVEY_REPLIES_SUCCESS"
export const GET_PLACE_SURVEY_REPLIES_FAILED = "GET_PLACE_SURVEY_REPLIES_FAILED"

export const SHOW_BULK_UPLOAD_MODAL = "SHOW_BULK_UPLOAD_MODAL"
export const HIDE_BULK_UPLOAD_MODAL = "HIDE_BULK_UPLOAD_MODAL"

export const UPLOAD_BULK_PLACES = "UPLOAD_BULK_PLACES"
export const UPLOAD_BULK_PLACES_SUCCESS = "UPLOAD_BULK_PLACES_SUCCESS"
export const UPLOAD_BULK_PLACES_FAILED = "UPLOAD_BULK_PLACES_FAILED"
export const SET_BULK_UPLOAD_FLAG = "SET_BULK_UPLOAD_FLAG"

export const GET_PLACES_WITH_CHAPTERS = "GET_PLACES_WITH_CHAPTERS"
export const GET_PLACES_WITH_CHAPTERS_SUCCESS =
  "GET_PLACES_WITH_CHAPTERS_SUCCESS"
export const GET_PLACES_WITH_CHAPTERS_FAILED = "GET_PLACES_WITH_CHAPTERS_FAILED"

export const GET_CHAPTERS = "GET_CHAPTERS"
export const GET_CHAPTERS_SUCCESS = "GET_CHAPTERS_SUCCESS"
export const GET_CHAPTERS_FAILED = "GET_CHAPTERS_FAILED"

export const GET_PLACES_REPORTS = "GET_PLACES_REPORTS"
export const GET_PLACES_REPORTS_SUCCESS = "GET_PLACES_REPORTS_SUCCESS"
export const GET_PLACES_REPORTS_FAILED = "GET_PLACES_REPORTS_FAILED"

export const GET_PLACES_SUMMARY_REPORTS = "GET_PLACES_SUMMARY_REPORTS"
export const GET_PLACES_SUMMARY_REPORTS_SUCCESS =
  "GET_PLACES_SUMMARY_REPORTS_SUCCESS"
export const GET_PLACES_SUMMARY_REPORTS_FAILED =
  "GET_PLACES_SUMMARY_REPORTS_FAILED"
